import { getParent, getRoot, types } from 'mobx-state-tree';
import { companyData } from './companyData';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
// import { toJS } from 'mobx';
const MAX_COMPANIES_STORAGE_SIZE = 10;
const CompanyListItem = types.model('CompanyListItem', {
  accountId: types.maybeNull(types.string),
  activeProperties: types.number,
  code: types.string,
  companyId: types.string,
  companyName: types.maybeNull(types.string),
  createdOn: types.maybeNull(types.string),
  deactivatedProperties: types.number,
  email: types.maybeNull(types.string),
  inactiveProperties: types.number,
  phone: types.maybeNull(types.string),
  tagIds: types.maybeNull(types.array(types.string)),
  accessToken: types.maybeNull(types.string),
  expiresOn: types.maybeNull(types.string)
}).actions(store => {
  return {
    setCompanyAccessData(payload) {
      store.accessToken = payload.accessToken;
      store.expiresOn = payload.expiresOn;
    }
  };
}).views(store => ({
  get companyHasAccessToken() {
    return store.accessToken !== null;
  },
  get companyAccessData() {
    return {
      accessToken: store.accessToken,
      expiresOn: store.expiresOn
    };
  }
}));
const HomeDashboard = types.model('HomeDashboardModel', {
  companies: types.optional(types.array(companyData), []),
  companyAccessId: types.optional(types.string, localStorage.getItem(USER_SETTINGS_KEYS.company) || 'some_company_id'),
  portfolioId: types.optional(types.string, 'all'),
  propertyId: types.optional(types.maybeNull(types.string), 'all'),
  companyAdminList: types.optional(types.array(CompanyListItem), []),
  companyAdminListTotal: types.optional(types.maybeNull(types.number), 0),
  enableShortcutsHint: types.optional(types.boolean, false),
  companiesNavOpen: types.optional(types.boolean, true),
  // Opened by default
  currentAbortController: types.frozen(null)
}).actions(store => {
  return {
    setAbortController(controller) {
      store.currentAbortController = controller;
    },
    /** Align MST selection with JWT/localStorage so getCurrentCompany matches after registration (avoids stale default id). */
    ensureCompanyAccessIdMatchesSession(companyId) {
      if (!companyId || companyId === 'undefined' || companyId === 'null') {
        return;
      }
      if (store.companyAccessId !== companyId) {
        store.companyAccessId = companyId;
      }
    },
    selectActivePortfolioId(id) {
      var _store$currentAbortCo;
      if ((_store$currentAbortCo = store.currentAbortController) !== null && _store$currentAbortCo !== void 0 && _store$currentAbortCo.signal.aborted) return;
      store.portfolioId = id;
      getRoot(store).residenciesMultiActionStore.deselectAll();
      // Note: temporary cheat to disable select all properties option
      // getParent(store).homeDashboardStore.selectActivePropertyId(
      //   toJS(getParent(store).homeDashboardStore.getCurrentCompanyProperties)[0]?.id
      // );
    },
    selectActivePropertyId(id, prefetchDataOnly) {
      var _store$currentAbortCo2, _store$companies$comp4, _store$companies$comp5;
      if ((_store$currentAbortCo2 = store.currentAbortController) !== null && _store$currentAbortCo2 !== void 0 && _store$currentAbortCo2.signal.aborted) return;
      if (!prefetchDataOnly || id === null || id === 'portfolio_details') {
        getRoot(store).residenciesMultiActionStore.deselectAll();
        store.propertyId = id;
        if (id === null || id === 'portfolio_details') {
          return;
        }
      }
      const propertyIdInternal = id;
      if (!id) return;
      const companyIndex = store.companies.findIndex(company => company.id === store.companyAccessId);
      if (propertyIdInternal === 'all') {
        var _store$companies$comp;
        // Note: temporary cheat to disable select all properties option
        // NOTE: commented because of implementation of New Billing List view
        // store.propertyId = getParent(store).homeDashboardStore.getCurrentCompanyProperties[0]?.id;
        if (companyIndex !== -1) (_store$companies$comp = store.companies[companyIndex]) === null || _store$companies$comp === void 0 || (_store$companies$comp = _store$companies$comp.companyResidentsTabOptions) === null || _store$companies$comp === void 0 || _store$companies$comp.updateModel({
          includeEmptyUnitsFlag: false
        });
      }
      let portfolioIdExt, propertyIdExt;
      if (store.portfolioId === 'all') {
        var _store$companies$comp3;
        const _store$companies$comp2 = (_store$companies$comp3 = store.companies[companyIndex]) === null || _store$companies$comp3 === void 0 ? void 0 : _store$companies$comp3.portfolios.reduce((acc, portfolio) => {
            // const resultPropertyIndex = portfolio.properties.findIndex(property => property.id === store.propertyId);
            const resultPropertyIndex = portfolio.properties.findIndex(property => property.id === propertyIdInternal);
            if (resultPropertyIndex === -1) {
              return acc;
            } else return {
              portfolioId: portfolio.id,
              propertyId: portfolio.properties[resultPropertyIndex].id
            };
          }, {
            portfolioId: undefined,
            propertyId: undefined
          }),
          portfolioId = _store$companies$comp2.portfolioId,
          propertyId = _store$companies$comp2.propertyId;
        portfolioIdExt = portfolioId;
        propertyIdExt = propertyId;
      }
      if (((_store$companies$comp4 = store.companies[companyIndex].portfolios.find(portfolio => portfolio.id === store.portfolioId)
      // ?.properties.find(property => property.id === store.selectedPropertyId)?.buildingInformation === null ||
      ) === null || _store$companies$comp4 === void 0 || (_store$companies$comp4 = _store$companies$comp4.properties.find(property => property.id === propertyIdInternal)) === null || _store$companies$comp4 === void 0 ? void 0 : _store$companies$comp4.buildingInformation) === null || ((_store$companies$comp5 = store.companies[companyIndex].portfolios.find(portfolio => portfolio.id === portfolioIdExt)) === null || _store$companies$comp5 === void 0 || (_store$companies$comp5 = _store$companies$comp5.properties.find(property => property.id === propertyIdExt)) === null || _store$companies$comp5 === void 0 ? void 0 : _store$companies$comp5.buildingInformation) === null) {
        if (companyIndex !== -1) {
          store.companies[companyIndex].fetchPropertyInformation({
            // propertyId: store.portfolioId === 'all' ? propertyIdExt : store.selectedPropertyId,
            propertyId: store.portfolioId === 'all' ? propertyIdExt : propertyIdInternal,
            portfolioId: store.portfolioId === 'all' ? portfolioIdExt : store.selectedPortfolioId
          });
          store.companies[companyIndex].fetchBuildingInformation({
            // propertyId: store.portfolioId === 'all' ? propertyIdExt : store.selectedPropertyId,
            propertyId: store.portfolioId === 'all' ? propertyIdExt : propertyIdInternal,
            portfolioId: store.portfolioId === 'all' ? portfolioIdExt : store.selectedPortfolioId
          });
          store.companies[companyIndex].fetchPropertyCommonAreaAmenities({
            propertyId: store.portfolioId === 'all' ? propertyIdExt : propertyIdInternal,
            portfolioId: store.portfolioId === 'all' ? portfolioIdExt : store.selectedPortfolioId
          });
        }
      }
      store.companies[companyIndex].fetchCommonAreaAmenities();
      if (store.portfolioId !== 'all' && getParent(store).account.featureFlagsStore.getIsFailedInvoicePaymentEnabled) store.companies[companyIndex].fetchPropertyPaymentMethod({
        propertyId: propertyIdInternal
      });
      if (!prefetchDataOnly && store.companies[companyIndex].companyFeatureSet.isAppfolio) {
        store.companies[companyIndex].fetchCompanyAppfolioGlCodes({
          propertyId: propertyIdExt !== null && propertyIdExt !== void 0 ? propertyIdExt : propertyIdInternal,
          customInProgressFetchId: [propertyIdExt !== null && propertyIdExt !== void 0 ? propertyIdExt : propertyIdInternal]
        });
        // TODO: fix it to fetch GL accounts for Appfolio same as GLCodes
        getRoot(store).credentials.getGLAccountsAsync.run({
          applyToHomeDashboard: true
        }, [propertyIdExt !== null && propertyIdExt !== void 0 ? propertyIdExt : propertyIdInternal]);
      }
    },
    storeNewCompany(payload) {
      try {
        var _store$currentAbortCo3;
        if ((_store$currentAbortCo3 = store.currentAbortController) !== null && _store$currentAbortCo3 !== void 0 && _store$currentAbortCo3.signal.aborted) return Promise.resolve();
        if (store.companies.length > MAX_COMPANIES_STORAGE_SIZE) {
          store.companies.shift();
        }
        const existingCompanyIndex = store.companies.findIndex(company => company.id === payload.id);
        const companyUtilityIds = Array.from(new Set(payload.portfolios.map(portfolio => {
          var _portfolio$properties;
          return portfolio === null || portfolio === void 0 || (_portfolio$properties = portfolio.properties) === null || _portfolio$properties === void 0 ? void 0 : _portfolio$properties.map(property => {
            var _property$dashboard;
            return property === null || property === void 0 || (_property$dashboard = property.dashboard) === null || _property$dashboard === void 0 ? void 0 : _property$dashboard.utilityIds;
          });
        }).flat(Infinity)));
        if (existingCompanyIndex !== -1) {
          var _store$companies$exis;
          store.companies[existingCompanyIndex].setUpdateCompanyPortfoliosData(payload);
          store.companies[existingCompanyIndex].fetchUtilitiesInfo(companyUtilityIds);
          store.companies[existingCompanyIndex].fetchCompanyTeamMembers();
          if ((_store$companies$exis = store.companies[existingCompanyIndex]) !== null && _store$companies$exis !== void 0 && _store$companies$exis.companyFeatureSet.isAppfolio) {
            store.companies[existingCompanyIndex].fetchCompanyAppfolioGlCodes();
          }
        } else {
          store.companies.push(payload);
          const newCompanyItem = store.getCompanyById(payload.id);
          newCompanyItem.fetchUtilitiesInfo(companyUtilityIds);
          newCompanyItem.fetchCompanyTeamMembers();
          if (newCompanyItem !== null && newCompanyItem !== void 0 && newCompanyItem.companyFeatureSet.isAppfolio) {
            newCompanyItem.fetchCompanyAppfolioGlCodes();
          }
          // newCompanyItem.fetchCompanyACHs();
          // newCompanyItem.fetchCompanyRegularChecks();
          newCompanyItem.fetchCompanyPayoutMethods();
          store.selectActivePropertyId('all');
          store.selectActivePortfolioId('all');
        }
        // Awaited by getPortfoliosDashboard so getCurrentCompany.name hydrates before UI continues (payload has no name).
        return getRoot(store).company.getCurrentUserCompanyFromTokenAsync.run();
      } catch (error) {
        console.log('HomeDashboard.storeNewCompany ERROR', {
          error
        });
        return Promise.resolve();
      }
    },
    setCompanyAccessId(id, accessPayload) {
      var _store$currentAbortCo4;
      if ((_store$currentAbortCo4 = store.currentAbortController) !== null && _store$currentAbortCo4 !== void 0 && _store$currentAbortCo4.signal.aborted) return;
      store.companyAccessId = id;
      if (accessPayload !== undefined) {
        store.companyAdminList.find(i => i.companyId === id).setCompanyAccessData(accessPayload);
      }
      return getRoot(store).company.getCurrentUserCompanyFromTokenAsync.run({}, [id + 'setCompanyAccessId']).then(async () => {
        return getRoot(store).portfolios.getPortfoliosDashboardAsync.run({
          storeCompany: true
        }, [id + 'setCompanyAccessId']).then(() => {
          store.selectActivePortfolioId('all');
          store.selectActivePropertyId('all');
        });
      });
    },
    setCompanyAdminListTotal(value) {
      store.companyAdminListTotal = value;
    },
    parseCompanyAdminList(payload) {
      var _store$currentAbortCo5;
      if ((_store$currentAbortCo5 = store.currentAbortController) !== null && _store$currentAbortCo5 !== void 0 && _store$currentAbortCo5.signal.aborted) return;
      if (!payload || !(payload !== null && payload !== void 0 && payload.length)) return;
      const companiesToAdd = payload.reduce((acc, company) => {
        const result = [...acc];
        const existingStoredCompanyListItemIndex = store.companyAdminList.findIndex(storedCompany => storedCompany.companyId === company.companyId);
        if (existingStoredCompanyListItemIndex !== -1) {
          // NOTE: directly update company if it's already exist in list
          store.companyAdminList[existingStoredCompanyListItemIndex] = company;
        } else {
          // NOTE: all not existing properties will be pushed into the list in batch
          result.push(company);
        }
        return result;
      }, []);
      store.companyAdminList.push(...companiesToAdd);
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    toggleShortcutsHint(state) {
      var _store$currentAbortCo6;
      if ((_store$currentAbortCo6 = store.currentAbortController) !== null && _store$currentAbortCo6 !== void 0 && _store$currentAbortCo6.signal.aborted) return;
      store.enableShortcutsHint = false;
    },
    changeCompaniesNavOpenState: state => {
      var _store$currentAbortCo7;
      if ((_store$currentAbortCo7 = store.currentAbortController) !== null && _store$currentAbortCo7 !== void 0 && _store$currentAbortCo7.signal.aborted) return;
      if (state === undefined) {
        store.companiesNavOpen = !store.companiesNavOpen;
      } else {
        store.companiesNavOpen = state;
      }
    }
  };
}).views(store => ({
  get selectedPortfolioId() {
    return store.portfolioId;
  },
  get selectedPropertyId() {
    return store.propertyId;
  },
  getCompanyById(id) {
    return store.companies.find(company => company.id === id) || null;
  },
  get getCurrentCompany() {
    return store.companies.find(company => company.id === store.companyAccessId);
  },
  get getCurrentCompanyPortfolios() {
    var _store$getCurrentComp;
    return (_store$getCurrentComp = store.getCurrentCompany) === null || _store$getCurrentComp === void 0 ? void 0 : _store$getCurrentComp.portfolios;
  },
  get getCurrentPortfolio() {
    var _store$getCurrentComp2;
    return ((_store$getCurrentComp2 = store.getCurrentCompanyPortfolios) === null || _store$getCurrentComp2 === void 0 ? void 0 : _store$getCurrentComp2.find(portfolio => portfolio.id === store.portfolioId)) || null;
  },
  get getCurrentCompanyProperties() {
    // NOTE: new implementation when we have a single list of properties for all portfolios
    if (store.portfolioId === 'all') {
      var _store$getCurrentComp3;
      return ((_store$getCurrentComp3 = store.getCurrentCompany) === null || _store$getCurrentComp3 === void 0 ? void 0 : _store$getCurrentComp3.propertyNavOptions.filteredItems) || [];
    } else {
      var _store$getCurrentComp4;
      return ((_store$getCurrentComp4 = store.getCurrentCompany) === null || _store$getCurrentComp4 === void 0 ? void 0 : _store$getCurrentComp4.propertyNavOptions.filteredItems.filter(property => property.propertyPortfolioInfo.id === store.portfolioId)) || [];
    }
  },
  get getCurrentCompanyPropertiesIdsByNavSelection() {
    if (store.propertyId === 'all') {
      var _store$getCurrentComp5;
      return (_store$getCurrentComp5 = store.getCurrentCompany) === null || _store$getCurrentComp5 === void 0 ? void 0 : _store$getCurrentComp5.portfolioNavOptions.filteredItems.map(portfolio => portfolio.properties).flat().map(property => property.id);
    } else {
      return [store.propertyId];
    }
  },
  get getCurrentCompanyPropertiesByNavSelection() {
    if (store.propertyId === 'all') {
      var _store$getCurrentComp6;
      return (_store$getCurrentComp6 = store.getCurrentCompany) === null || _store$getCurrentComp6 === void 0 ? void 0 : _store$getCurrentComp6.portfolioNavOptions.filteredItems.map(portfolio => portfolio.properties).flat();
    } else {
      return [store.getCurrentProperty];
    }
  },
  getPropertyById(propertyId) {
    var _store$getCurrentComp7;
    return ((_store$getCurrentComp7 = store.getCurrentCompany) === null || _store$getCurrentComp7 === void 0 || (_store$getCurrentComp7 = _store$getCurrentComp7.portfolios.find(portfolio => portfolio.properties.findIndex(property => property.id === propertyId) !== -1)) === null || _store$getCurrentComp7 === void 0 ? void 0 : _store$getCurrentComp7.properties.find(property => property.id === propertyId)) || null;
  },
  getPortfolioByPropertyId(propertyId) {
    var _store$getCurrentComp8;
    return (_store$getCurrentComp8 = store.getCurrentCompany) === null || _store$getCurrentComp8 === void 0 ? void 0 : _store$getCurrentComp8.portfolios.find(portfolio => portfolio.properties.findIndex(property => property.id === propertyId) !== -1);
  },
  getPortfolioById(portfolioId) {
    var _store$getCurrentComp9;
    return (_store$getCurrentComp9 = store.getCurrentCompany) === null || _store$getCurrentComp9 === void 0 ? void 0 : _store$getCurrentComp9.portfolios.find(portfolio => portfolio.id === portfolioId);
  },
  get getCurrentProperty() {
    if (store.propertyId === 'all') return null;
    // if (store.portfolioId === 'all' && store.propertyId !== 'all') { OLD VERSION
    if (store.propertyId !== 'all') {
      var _store$getCurrentComp0;
      return ((_store$getCurrentComp0 = store.getCurrentCompany) === null || _store$getCurrentComp0 === void 0 || (_store$getCurrentComp0 = _store$getCurrentComp0.portfolios.find(portfolio => portfolio.properties.findIndex(property => property.id === store.propertyId) !== -1)) === null || _store$getCurrentComp0 === void 0 ? void 0 : _store$getCurrentComp0.properties.find(property => property.id === store.propertyId)) || null;
    }

    // return (
    //   store.getCurrentCompany?.portfolios
    //     .find(portfolio => portfolio.id === store.portfolioId)
    //     ?.properties.find(property => property.id === store.propertyId) || null
    // );
  },
  get getCompanySelectorList() {
    return store.companyAdminList;
  },
  get getCompanyAdminListTotal() {
    return store.companyAdminListTotal;
  },
  get enableShortcutsHintState() {
    return store.enableShortcutsHint;
  }
}));
export const homeDashboardStore = types.optional(HomeDashboard, {});